import BaseApiAction from '@Actions/base-api-action';

export default class GetInvitesForTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getInvitesForTeam',
      payload: {
        team_id: this._payload.team_id
      },
      disableLoaders: true
    });
  }
}
GetInvitesForTeam